module.exports = __webpack_public_path__ + "img/question-circle.f505d475.svg";